import { render, staticRenderFns } from "./CurationListLink.vue?vue&type=template&id=2eee5d68&scoped=true"
import script from "./CurationListLink.vue?vue&type=script&lang=js"
export * from "./CurationListLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eee5d68",
  null
  
)

export default component.exports